var _defs, _path, _path2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconInitial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    className: "wasm-icon-linear-gradient",
    id: "wasm-initial-icon-linear-gradient",
    x1: 39.8,
    y1: 31.52,
    x2: 27.23,
    y2: 31.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46.08,14.81c2.56,0,4.84,1.63,5.66,4.05.79,2.32,1.49,11.78,1.95,18.04.19,2.56.35,4.78.51,6.45.05.51-.23,1.08-.84,1.17-.04,0-.07,0-.11,0-.4,0-.82-.34-.98-.79l-1.51-4.42c-.66-1.92-2.46-3.21-4.49-3.21-.52,0-1.04.09-1.53.26-2.23.76-3.91,3.24-2.8,6.5l1.35,3.95c.17.5,0,1.06-.38,1.28-.15.09-.31.13-.47.13-.35,0-.7-.2-.91-.53-.89-1.42-2.12-3.31-3.55-5.5-3.27-5.02-8.74-13.42-9.42-15.42-.52-1.51-.41-3.14.29-4.57.7-1.44,1.93-2.51,3.44-3.03.63-.21,1.27-.32,1.93-.32.15,0,.31,0,.46.02.25.02.51.03.76.03,2.46,0,4.82-.91,6.64-2.56.6-.54,1.3-.96,2.08-1.22.63-.21,1.28-.32,1.94-.32m0-2.78c-.94,0-1.9.15-2.83.47-1.16.4-2.19,1.02-3.04,1.79-1.3,1.18-3.02,1.84-4.78,1.84-.18,0-.36,0-.54-.02-.22-.02-.45-.03-.68-.03-.94,0-1.89.15-2.83.47-4.58,1.56-7.03,6.55-5.46,11.13,1.08,3.15,9.89,16.15,13.25,21.49.72,1.15,1.97,1.83,3.26,1.83.62,0,1.25-.16,1.84-.49,1.59-.9,2.24-2.87,1.65-4.6l-1.35-3.95c-.51-1.5.04-2.62,1.07-2.97h0c.21-.07.43-.11.64-.11.82,0,1.58.51,1.86,1.33l1.51,4.42c.54,1.57,2,2.67,3.61,2.67.17,0,.34-.01.52-.04,2.08-.31,3.39-2.18,3.21-4.18-.58-6.29-1.37-21.53-2.6-25.13-1.24-3.64-4.65-5.94-8.3-5.94h0Z",
    fill: "url(#wasm-initial-icon-linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m14.16,49.92V13.76h8.24v36.16h-8.24Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "wasm-icon-fill",
    x: 9.17,
    y: 13.76,
    width: 18.23,
    height: 6.06
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "wasm-icon-fill",
    x: 9.17,
    y: 43.86,
    width: 18.23,
    height: 6.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconInitial);
export default __webpack_public_path__ + "static/media/SDS_icon_Initial.6d1debf3373ef70e38c37aa6f0140bd5.svg";
export { ForwardRef as ReactComponent };